import { jsx } from 'react/jsx-runtime';
import { createContext, useContext } from 'react';
import { DynamicAuthLayout } from '../../layout/DynamicAuthLayout/DynamicAuthLayout.js';
import { FooterAnimationContextProvider } from '../FooterAnimationContext/index.js';
import { ThemeContextProvider } from '../ThemeContext/ThemeContext.js';
import { ViewContext } from '../ViewContext/ViewContext.js';
import { useInternalDynamicContext } from '../DynamicContext/useInternalDynamicContext.js';
import { ErrorContextProvider } from '../ErrorContext/ErrorContext.js';
import '@dynamic-labs/sdk-api';
import '../../shared/logger.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/multi-wallet';
import '../../utils/constants/colors.js';
import { defaultWalletsForChains } from '../../shared/consts/index.js';

const MockContext = createContext(undefined);
const MockContextProvider = ({ children, walletName, view, mockedWalletConnector, customerTheme, dynamicLayoutClassName, }) => {
    const viewContextValue = {
        /* istanbul ignore next */
        setView: () => { },
        view,
    };
    return (jsx(MockContext.Provider, Object.assign({ value: { mockedSDK: true } }, { children: jsx(ViewContext.Provider, Object.assign({ value: viewContextValue }, { children: jsx(ErrorContextProvider, { children: jsx(ThemeContextProvider, Object.assign({ customerTheme: customerTheme }, { children: jsx(FooterAnimationContextProvider, { children: jsx(MockContextWrapper, Object.assign({ dynamicLayoutClassName: dynamicLayoutClassName, mockedWalletConnector: mockedWalletConnector, walletName: walletName }, { children: children })) }) })) }) })) })));
};
const MockContextWrapper = ({ dynamicLayoutClassName, mockedWalletConnector, walletName, children, }) => {
    const { appName, privacyPolicyUrl, termsOfServiceUrl } = useInternalDynamicContext();
    /* istanbul ignore next */
    const onClose = () => new Promise(() => { });
    const mockProjectSettings = {
        chains: [],
        design: {},
        general: {},
        kyc: [],
        privacy: {},
        sdk: { walletConnect: { projectId: '', v2Enabled: false } },
        security: {},
    };
    return (jsx("div", Object.assign({ className: 'mock-ctx__container', style: { position: 'relative' } }, { children: jsx(DynamicAuthLayout, Object.assign({ className: dynamicLayoutClassName, appName: appName, onClose: onClose, walletName: walletName, newToWeb3WalletChainMap: defaultWalletsForChains, projectSettings: mockProjectSettings, transitionProps: {
                isShown: true,
            }, walletConnector: mockedWalletConnector !== null && mockedWalletConnector !== void 0 ? mockedWalletConnector : {
                canConnectViaQrCode: true,
                name: walletName,
            }, privacyPolicyUrl: privacyPolicyUrl, termsOfServiceUrl: termsOfServiceUrl }, { children: children })) })));
};
const useMockContext = () => {
    const context = useContext(MockContext);
    if (context === undefined) {
        return { mockedSDK: false };
    }
    return context;
};

export { MockContext, MockContextProvider, MockContextWrapper, useMockContext };
